<mat-progress-bar appShowWhenLoading mode="indeterminate"></mat-progress-bar>

<router-outlet></router-outlet>
